module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Castille\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('I', [_vm._v("New York Times")]), _vm._v(" and "), _c('I', [_vm._v("USA Today ")]), _vm._v("bestselling author of the dark, gritty biker romance, "), _c('I', [_vm._v("Rough Justice")]), _vm._v(", Sarah Castille, worked and travelled abroad before trading her briefcase and stilettos for a handful of magic beans and a home near the Canadian Rockies. She writes contemporary erotic romance and romantic suspense featuring blazingly hot alpha heroes and the women who tame them.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17rj88D/tc-custom/9781466860407.jpg?1731184708445",
      "alt": "This image is the cover for the book Rough Justice, The Sinner's Tribe Motorcycle Club"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rough Justice, The Sinner's Tribe Motorcycle Club\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("From "), _c('i', [_vm._v("New York Times ")]), _vm._v("bestselling author Sarah Castille comes "), _c('i', [_vm._v("Rough Justice, ")]), _vm._v("a scorching new series featuring red-hot, hard-riding bikers and the women who can't help but love them…")]), _c('br'), _c('b', [_vm._v("IT TAKES A GOOD, STRONG WOMAN ")]), _c('br'), _vm._v("Raised in a motorcycle gang, tough, beautiful Arianne Wilder has always dreamed of a normal life. But no sooner does she escape her father's domineering grasp than she wakes up to find herself in a rival gang's clubhouse—at the mercy of the dangerously sexy Jagger Knight."), _c('br'), _c('b', [_vm._v("TO TAME A MAN WHO'S HELL ON WHEELS.")]), _c('br'), _vm._v("The alpha leader of the notorious Sinner's Tribe, Jagger Knight is all muscle, all biker, and all man. But somewhere inside this hard, tattooed outlaw, Arianne senses a kindred spirit—and she can't ignore their tempestuous attraction. Can she beat him at his own game in a revved-up blaze of glory? Or will their passion spark a war that's the end of the road for them both?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Paperbacks\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0